import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import './ImageGrid.css';

export const ImageGrid = ({ images }: any) => {
  return (
    <div className="grid-gallery">
      {images.map((image: any, index: any) => (
        <div key={index} className="grid-item">
          <Zoom>
            <img
              src={image}
              alt={`${index + 1}`}
              style={{ width: '100%', height: 'auto', cursor: 'pointer' }}
            />
          </Zoom>
        </div>
      ))}
    </div>
  );
};
